import type { Environment } from './environment-type';

export const baseEnvironment: Omit<Environment, 'coreApiUrl' | 'AngularJsBaseUrl'> = {
  local: false,
  production: false,
  AppBaseHref: '/app/',
  featureFlags: {
    customActivities: false,
    qrCodeLogin: true
  },
  fileManagerOptions: {
    allowedFileExtensions: 'doc,docx,pdf,xls,xlsx,txt,csv,html,psd,sql,log,fla,xml,ade,adp,ppt,pptx,zip,rar',
    allowedImageExtensions: 'jpg,jpeg,png,gif,bmp,tiff,svg',
    allowedMusicExtensions: 'mp3,m4a,ac3,aiff,mid',
    allowedVideoExtensions: 'mov,mpeg,mp4,avi,mpg,wma',
    captureStudentThinking: {
      allowedFileExtensions: 'jpg,jpeg,png,gif,bmp,tiff,svg,doc,docx,pdf,txt',
      maxUploadSizeMb: 100
    },
    maxUploadSizeMb: 100
  },
  googleClientId: '85174641190-mrh5n47sl23a2nm3h6snbnamocjl66hk.apps.googleusercontent.com',
  IdentityServerCreditails: {
    clientId: 'Web'
  },
  imageBasePath: 'images',
  MatomoSiteId: '6',
  MatomoUrl: 'https://ma.knowledgehook.com/',
  serverLogEnabled: false,
  soundsBasePath: 'sounds',
  staticContentRootUrl: 'https://staticcontent.knowledgehook.com',
  stripePublicKey: 'pk_test_51SL9EzS7IgF5XkTag27tmwnuaLK8dzqyDGj6htS7n0Sv6deOODdvqMtgF9DX94RzwYwDmCeS2c5nrEOroayFMsVD009w1UZY49',
  supportEmail: 'support@knowledgehook.com',
  turnstileSiteKey: '0x4AAAAAAAcgU0Dt5dJ_T2sE',
  zendescAccountUrl: 'knowledgehook.zendesk.com',
  // For local testing with MMS running locally
  mmsUrl: 'http://localhost:4080',
  analyticsSampling: {
    gsPerfPercentage: 100
  },
  clientVersion: null,
  cookieConsentExpiryDays: 180
};
